import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cdd73ed0 = () => interopDefault(import('../../../pages/access_disabled/index.vue' /* webpackChunkName: "pages/access_disabled/index" */))
const _16a679f4 = () => interopDefault(import('../../../pages/architectural_submissions/index.vue' /* webpackChunkName: "pages/architectural_submissions/index" */))
const _2b7d0c2b = () => interopDefault(import('../../../pages/change_password/index.vue' /* webpackChunkName: "pages/change_password/index" */))
const _69238b42 = () => interopDefault(import('../../../pages/contracts/index.vue' /* webpackChunkName: "pages/contracts/index" */))
const _8b6f068c = () => interopDefault(import('../../../pages/health_check/index.vue' /* webpackChunkName: "pages/health_check/index" */))
const _4e1ea20a = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _25ce5857 = () => interopDefault(import('../../../pages/lots/index.vue' /* webpackChunkName: "pages/lots/index" */))
const _1a9d2981 = () => interopDefault(import('../../../pages/misc/index.vue' /* webpackChunkName: "pages/misc/index" */))
const _37b76444 = () => interopDefault(import('../../../pages/parcel/index.vue' /* webpackChunkName: "pages/parcel/index" */))
const _f05f006a = () => interopDefault(import('../../../pages/plans/index.vue' /* webpackChunkName: "pages/plans/index" */))
const _1114f760 = () => interopDefault(import('../../../pages/reports/index.vue' /* webpackChunkName: "pages/reports/index" */))
const _0829d989 = () => interopDefault(import('../../../pages/unauthorized/index.vue' /* webpackChunkName: "pages/unauthorized/index" */))
const _dfd699d0 = () => interopDefault(import('../../../pages/access_disabled/cookies/index.vue' /* webpackChunkName: "pages/access_disabled/cookies/index" */))
const _472b6b60 = () => interopDefault(import('../../../pages/neighbors/editor/index.vue' /* webpackChunkName: "pages/neighbors/editor/index" */))
const _4ad65230 = () => interopDefault(import('../../../pages/password/reset/index.vue' /* webpackChunkName: "pages/password/reset/index" */))
const _5c73974c = () => interopDefault(import('../../../pages/plans/add.vue' /* webpackChunkName: "pages/plans/add" */))
const _b819f6d8 = () => interopDefault(import('../../../pages/password/reset/done.vue' /* webpackChunkName: "pages/password/reset/done" */))
const _46fa594c = () => interopDefault(import('../../../pages/v3/map/_slug/index.vue' /* webpackChunkName: "pages/v3/map/_slug/index" */))
const _5ac9b222 = () => interopDefault(import('../../../pages/v3/rental_map/_slug/index.vue' /* webpackChunkName: "pages/v3/rental_map/_slug/index" */))
const _3446d25f = () => interopDefault(import('../../../pages/v3/map/_slug/favorites.vue' /* webpackChunkName: "pages/v3/map/_slug/favorites" */))
const _e9fc0e1c = () => interopDefault(import('../../../pages/v3/map/_slug/plans.vue' /* webpackChunkName: "pages/v3/map/_slug/plans" */))
const _0dfb6282 = () => interopDefault(import('../../../pages/v3/map/_slug/shared-with-me.vue' /* webpackChunkName: "pages/v3/map/_slug/shared-with-me" */))
const _0f9d5918 = () => interopDefault(import('../../../pages/v3/rental_map/_slug/favorites.vue' /* webpackChunkName: "pages/v3/rental_map/_slug/favorites" */))
const _5c5632ca = () => interopDefault(import('../../../pages/v3/rental_map/_slug/shared-with-me.vue' /* webpackChunkName: "pages/v3/rental_map/_slug/shared-with-me" */))
const _60159a2c = () => interopDefault(import('../../../pages/password/reset/_key/_token/index.vue' /* webpackChunkName: "pages/password/reset/_key/_token/index" */))
const _387c7652 = () => interopDefault(import('../../../pages/lots/_slug/index.vue' /* webpackChunkName: "pages/lots/_slug/index" */))
const _9b11c716 = () => interopDefault(import('../../../pages/map/_slug.vue' /* webpackChunkName: "pages/map/_slug" */))
const _9a8ccfae = () => interopDefault(import('../../../pages/misc/_id.vue' /* webpackChunkName: "pages/misc/_id" */))
const _c74f9274 = () => interopDefault(import('../../../pages/plans/_slug/index.vue' /* webpackChunkName: "pages/plans/_slug/index" */))
const _1bb02aca = () => interopDefault(import('../../../pages/reports/_slug/index.vue' /* webpackChunkName: "pages/reports/_slug/index" */))
const _444efc73 = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _1c25ea01 = () => interopDefault(import('../../../pages/lots/_slug/construction.vue' /* webpackChunkName: "pages/lots/_slug/construction" */))
const _7ca58121 = () => interopDefault(import('../../../pages/lots/_slug/lot_management.vue' /* webpackChunkName: "pages/lots/_slug/lot_management" */))
const _e732382a = () => interopDefault(import('../../../pages/lots/_slug/spec.vue' /* webpackChunkName: "pages/lots/_slug/spec" */))
const _4d3efbc6 = () => interopDefault(import('../../../pages/plans/_slug/edit.vue' /* webpackChunkName: "pages/plans/_slug/edit" */))
const _fa30f2aa = () => interopDefault(import('../../../pages/lots/_slug/sales/build.vue' /* webpackChunkName: "pages/lots/_slug/sales/build" */))
const _f3151036 = () => interopDefault(import('../../../pages/lots/_slug/sales/contract.vue' /* webpackChunkName: "pages/lots/_slug/sales/contract" */))
const _6582ca84 = () => interopDefault(import('../../../pages/plans/_slug/elevations/add.vue' /* webpackChunkName: "pages/plans/_slug/elevations/add" */))
const _61529b6c = () => interopDefault(import('../../../pages/plans/_slug/elevations/_id/edit.vue' /* webpackChunkName: "pages/plans/_slug/elevations/_id/edit" */))
const _312b69b0 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/access_disabled",
    component: _cdd73ed0,
    name: "access_disabled"
  }, {
    path: "/architectural_submissions",
    component: _16a679f4,
    name: "architectural_submissions"
  }, {
    path: "/change_password",
    component: _2b7d0c2b,
    name: "change_password"
  }, {
    path: "/contracts",
    component: _69238b42,
    name: "contracts"
  }, {
    path: "/health_check",
    component: _8b6f068c,
    name: "health_check"
  }, {
    path: "/login",
    component: _4e1ea20a,
    name: "login"
  }, {
    path: "/lots",
    component: _25ce5857,
    name: "lots"
  }, {
    path: "/misc",
    component: _1a9d2981,
    name: "misc"
  }, {
    path: "/parcel",
    component: _37b76444,
    name: "parcel"
  }, {
    path: "/plans",
    component: _f05f006a,
    name: "plans"
  }, {
    path: "/reports",
    component: _1114f760,
    name: "reports"
  }, {
    path: "/unauthorized",
    component: _0829d989,
    name: "unauthorized"
  }, {
    path: "/access_disabled/cookies",
    component: _dfd699d0,
    name: "access_disabled-cookies"
  }, {
    path: "/neighbors/editor",
    component: _472b6b60,
    name: "neighbors-editor"
  }, {
    path: "/password/reset",
    component: _4ad65230,
    name: "password-reset"
  }, {
    path: "/plans/add",
    component: _5c73974c,
    name: "plans-add"
  }, {
    path: "/password/reset/done",
    component: _b819f6d8,
    name: "password-reset-done"
  }, {
    path: "/v3/map/:slug",
    component: _46fa594c,
    name: "v3-map-slug"
  }, {
    path: "/v3/rental_map/:slug",
    component: _5ac9b222,
    name: "v3-rental_map-slug"
  }, {
    path: "/v3/map/:slug?/favorites",
    component: _3446d25f,
    name: "v3-map-slug-favorites"
  }, {
    path: "/v3/map/:slug?/plans",
    component: _e9fc0e1c,
    name: "v3-map-slug-plans"
  }, {
    path: "/v3/map/:slug?/shared-with-me",
    component: _0dfb6282,
    name: "v3-map-slug-shared-with-me"
  }, {
    path: "/v3/rental_map/:slug?/favorites",
    component: _0f9d5918,
    name: "v3-rental_map-slug-favorites"
  }, {
    path: "/v3/rental_map/:slug?/shared-with-me",
    component: _5c5632ca,
    name: "v3-rental_map-slug-shared-with-me"
  }, {
    path: "/password/reset/:key/:token",
    component: _60159a2c,
    name: "password-reset-key-token"
  }, {
    path: "/lots/:slug",
    component: _387c7652,
    name: "lots-slug"
  }, {
    path: "/map/:slug?",
    component: _9b11c716,
    name: "map-slug"
  }, {
    path: "/misc/:id",
    component: _9a8ccfae,
    name: "misc-id"
  }, {
    path: "/plans/:slug",
    component: _c74f9274,
    name: "plans-slug"
  }, {
    path: "/reports/:slug",
    component: _1bb02aca,
    name: "reports-slug"
  }, {
    path: "/settings/:section",
    component: _444efc73,
    name: "settings-section"
  }, {
    path: "/lots/:slug/construction",
    component: _1c25ea01,
    name: "lots-slug-construction"
  }, {
    path: "/lots/:slug/lot_management",
    component: _7ca58121,
    name: "lots-slug-lot_management"
  }, {
    path: "/lots/:slug/spec",
    component: _e732382a,
    name: "lots-slug-spec"
  }, {
    path: "/plans/:slug/edit",
    component: _4d3efbc6,
    name: "plans-slug-edit"
  }, {
    path: "/lots/:slug/sales/build",
    component: _fa30f2aa,
    name: "lots-slug-sales-build"
  }, {
    path: "/lots/:slug/sales/contract",
    component: _f3151036,
    name: "lots-slug-sales-contract"
  }, {
    path: "/plans/:slug/elevations/add",
    component: _6582ca84,
    name: "plans-slug-elevations-add"
  }, {
    path: "/plans/:slug/elevations/:id?/edit",
    component: _61529b6c,
    name: "plans-slug-elevations-id-edit"
  }, {
    path: "/",
    component: _312b69b0,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
